<template>
    <div class="cashSection">
        <div class="csLabel">{{ $t('UserStockWatchingList.portfolio.cash') }}</div>
        <div v-if="editCash"  class="csValue">
            <v-text-field v-model="cashValue" :label="$t('UserStockWatchingList.portfolio.cash')" outlined dark dense type="number" :hide-details="true"></v-text-field>
            <v-btn @click="saveCashClicked" icon small color="white" class="editBtn">
                <font-awesome-icon :icon="icons.save" class="fa-fw fa-lg"></font-awesome-icon>
            </v-btn>
        </div>
        <div v-else class="csValue">
            <div class="pname">{{ amountOfMoney }}</div>
            <v-btn @click="editCashClicked" icon small color="white" class="editBtn">
                <font-awesome-icon :icon="icons.edit" class="fa-fw fa-lg"></font-awesome-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import StockHtmlHelper from '../stocks/StockHtmlHelper'
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { faPen } from '@fortawesome/pro-solid-svg-icons';

export default {
    props: ['portfolio'],
    data() {
        return {
            icons: {
                edit: faPen,
                save: faCheck
            },
            stockHTMLHelper: undefined,
            cashValue: 0,
            editCash: false
        }
    },
    created() {
        this.stockHTMLHelper = new StockHtmlHelper()
    },
    computed: {
        amountOfMoney() {
            if (this.portfolio) {
                const val = this.portfolio.amountOfMoney || 0
                return this.stockHTMLHelper.formatPriceWithLocaleCurrency(val, this.portfolio.currency, this.$i18n.locale)
            }
            return 0
        }
    },
    methods: {
        editCashClicked() {
            this.editCash = true
            this.cashValue = this.portfolio.amountOfMoney
        },
        saveCashClicked() {
            const amountOfMoney = parseFloat(this.cashValue) || 0
            this.$store.dispatch('updatePortfolioAmountOfMoney', { portfolioId: this.portfolio.id, amountOfMoney })
                .then(() => {
                    console.log('Portfolio amount of money updated successfully')
                })
                .catch((error) => {
                    console.error('Error updating portfolio amount of money:', error)
                })
                .finally(() => {
                    this.editCash = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
    .cashSection {
        display: flex;
        flex-direction: column;
        gap: 5px;
        font-size: 1.2em;
        .csLabel {
            color: #AAA;
        }
        .csValue {
            display: flex;
            gap: 15px;
            align-items: center;
            font-weight: bold;
        }
    }
</style>